import {Component, Injector, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../../../main/services';
import {
    DeliveryPointStruct, IataServiceLevelStruct, RefuelerCompanyCodeStruct} from '../../../../../common/models';
import { Contract } from '../../../../models';
import {createProductServiceForm} from '../../../../forms';
import {ProductService, ProductServiceStruct} from '../../../../models/product-service/product-service';
import {DeliveryPointService} from '../../../../../common/services/delivery-point/delivery-point.service';
import {IataServiceLevelService, RefuelerCompanyCodeService} from '../../../../../common/services';
import {ContractProductServiceService} from '../../../../services';
import {ActivatedRoute, Router} from '@angular/router';
import {EditProductServiceModalComponent} from "../..";

@Component({
    selector: 'jft-product-service-modal',
    templateUrl: './product-service-modal.component.html',
    styleUrls: ['./product-service-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductServiceModalComponent implements OnInit {

    public form: UntypedFormGroup;
    public productServices: ProductServiceStruct[] = [];
    public deliveryPoints: DeliveryPointStruct[];
    public iataServiceLevels: IataServiceLevelStruct[];
    public refuelerCompanyCodes: RefuelerCompanyCodeStruct[];
    public tenderId: string;
    public modalReference: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        public contract: Contract,
        private toast: ToastService,
        private service: ContractProductServiceService,
        private deliveryPointService: DeliveryPointService,
        private iataServiceLevelService: IataServiceLevelService,
        private refuelerCompanyCodeService: RefuelerCompanyCodeService,
        private activeModal: NgbActiveModal,
        private injector: Injector,
        private ngbModal: NgbModal
    ) {
    }

    public ngOnInit() {
        this.tenderId = this.route.parent.snapshot.params.id;
        this.getProductsServices();
        this.getDeliveryPoints();
        this.getIataServiceLevelService();
        this.getRefuelerCompanyCode();

        this.form = createProductServiceForm({});
    }

    public getProductsServices() {
        this.service.fetch(this.tenderId, this.contract.id).subscribe((item: ProductServiceStruct[]) => {
            this.productServices = item;
        })
    }

    private getDeliveryPoints() {
        this.deliveryPointService.fetch().subscribe((item: DeliveryPointStruct[]) => {
            this.deliveryPoints = item;
        }, e => {
            console.error(e);
        });
    }

    private getIataServiceLevelService() {
        this.iataServiceLevelService.fetch().subscribe((item: IataServiceLevelStruct[]) => {
            this.iataServiceLevels = item;
        }, e => {
            console.error(e);
        });
    }

    private getRefuelerCompanyCode() {
        this.refuelerCompanyCodeService.fetch().subscribe((item: RefuelerCompanyCodeStruct[]) => {
            this.refuelerCompanyCodes = item;
        }, e => {
            console.error(e);
        });
    }

    public close() {
        this.activeModal.dismiss();
    }

    public submit() {
        this.service.create(this.tenderId, this.contract.id, this.form.value).subscribe(() => {
            this.toast.success('Product updated');
            this.close();
        }, (e) => {
            this.toast.error(e);
        });
    }

    public getFormGroupErrorClasses(control: AbstractControl, isInvalid: boolean = false): {} {
        if (isInvalid) {
            return {'is-invalid': control.invalid};
        }
        return {'is-invalid': control.invalid && control.touched};
    }

    public showErrorBlock(control: AbstractControl): boolean {
        return control.errors && (control.dirty || control.touched);
    }

    public addProductService(productService: ProductServiceStruct = null) {
        this.modalReference = this.ngbModal.open(EditProductServiceModalComponent, {
            injector: Injector.create([
                {provide: Contract, useValue: this.contract},
                {provide: ProductService, useValue: productService}
            ], this.injector),
            size: 'lg',
            backdrop: 'static'
        }).result.then(() => {
            this.getProductsServices();
        }, (error) => {
            this.getProductsServices();
        });
    }

    public delete(productService: ProductServiceStruct) {
        this.service.delete(this.tenderId, this.contract.id, productService.id)
        .subscribe((data) => {
            let index = this.productServices.indexOf(productService);
            this.productServices.splice(index, 1);
            this.toast.success(`Product service removed`);
        }, (e) => {
            this.toast.error(e);
        });
    }
}
